import angular from 'angular'

import settingIcons from './resources/icons.resource'
import settingLabels from './resources/labels.resource'
import settingFields from './resources/fields.resource'

import $$setting from './services/setting.service'
import settingFormat from './services/format.service'
import settingRequests from './services/requests.service'
import settingResources from './services/resources.service'
import settingInit from './services/init.service'
import settingData from './services/data.service'
import settingMetadata from './services/metadata.service'

const name = 'setting'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('$$setting', $$setting)
  .factory('settingFormat', settingFormat)
  .factory('settingRequests', settingRequests)
  .factory('settingResources', settingResources)
  .factory('settingInit', settingInit)
  .factory('settingData', settingData)
  .factory('settingIcons', settingIcons)
  .factory('settingLabels', settingLabels)
  .factory('settingMetadata', settingMetadata)
  .factory('settingFields', settingFields)

export default 'setting'



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/setting.module.js